import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useOnboarding } from "@/hooks/useOnboarding";
import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard";
import { ROUTES } from "@/lib/routes";
import { Loader2 } from "lucide-react";

const Onboarding = () => {
  const navigate = useNavigate();
  const { user, isLoading: isAuthLoading } = useAuth();
  const { needsOnboarding, isLoading: isOnboardingLoading } = useOnboarding();

  useEffect(() => {
    // If not authenticated, redirect to auth
    if (!isAuthLoading && !user) {
      navigate(ROUTES.auth);
      return;
    }

    // If onboarding is already complete, redirect to activity
    if (!isOnboardingLoading && user && !needsOnboarding) {
      navigate(ROUTES.activity);
    }
  }, [user, isAuthLoading, needsOnboarding, isOnboardingLoading, navigate]);

  // Show loading while checking auth and onboarding status
  if (isAuthLoading || isOnboardingLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-primary" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If no user or onboarding complete, don't render (redirect will happen)
  if (!user || !needsOnboarding) {
    return null;
  }

  return <OnboardingWizard />;
};

export default Onboarding;
